/* eslint-disable func-names */
import Phaser from 'phaser';
import EDC from './globals';
import store from '@/store/index';
import router from '@/router/index';
import CursorManager from '@/components/games/shared/cursor-manager';

/**
 *
 */
EDC.UI.Button = function (scene, x, y) {
  this.scene = scene;
  this.sprites = {};
  this.states = {
    BTN_STATE_NORMAL: 'normal',
    BTN_STATE_HOVER: 'hover',
    BTN_STATE_DOWN: 'down',
    BTN_STATE_DISABLED: 'disabled',
  };
  this.x = x;
  this.y = y;
  this.container = null;
  this.clickCallback = null;
  this.overCallback = null;
  this.outCallback = null;
  this.cursorManager = null;

  this.interactiveAnimations = {};

  return this;
};
/**
 *
 */
EDC.UI.Button.prototype.create = function (normal, hover, down = null, disabled = null) {
  this.container = this.scene.add.container(this.x, this.y);

  this.addState(this.states.BTN_STATE_NORMAL, normal);
  this.addState(this.states.BTN_STATE_HOVER, hover);
  this.addState(this.states.BTN_STATE_DOWN, down);
  this.addState(this.states.BTN_STATE_DISABLED, disabled);

  const bounds = this.container.getBounds();
  this.container.setSize(bounds.width, bounds.height);
  this.container.setInteractive();

  this.container.on('pointerup', this.onUp, this);
  this.container.on('pointerdown', this.onDown, this);
  this.container.on('pointerover', this.onOver, this);
  this.container.on('pointerout', this.onOut, this);

  return this;
};
/**
 *
 */
EDC.UI.Button.prototype.show = function () {
  this.container.setVisible(true);
};
/**
 *
 */
EDC.UI.Button.prototype.hide = function () {
  this.container.setVisible(false);
};
/**
 *
 */
EDC.UI.Button.prototype.setScale = function (scale) {
  this.container.setScale(scale);
};
/**
 *
 */
EDC.UI.Button.prototype.getContainer = function () {
  return this.container;
};
/**
 *
 */
EDC.UI.Button.prototype.onUp = function () {
  if (this.sprites[this.states.BTN_STATE_DOWN]) {
    this.sprites[this.states.BTN_STATE_DOWN].setAlpha(0);
  }
  if (this.sprites[this.states.BTN_STATE_HOVER]) {
    this.sprites[this.states.BTN_STATE_HOVER].setAlpha(1);
  }
  if (this.clickCallback) {
    this.clickCallback();
  }
};
/**
 *
 */
EDC.UI.Button.prototype.onOver = function () {
  this.scene.tweens.add({
    targets: this.sprites[this.states.BTN_STATE_HOVER],
    alpha: 1,
    duration: 100,
    ease: 'Linear',
  });
  if (this.overCallback) {
    this.overCallback(this);
  }
};
/**
 *
 */
EDC.UI.Button.prototype.onOut = function () {
  if (this.sprites[this.states.BTN_STATE_DOWN]) {
    this.sprites[this.states.BTN_STATE_DOWN].setAlpha(0);
  }
  this.scene.tweens.add({
    targets: this.sprites[this.states.BTN_STATE_HOVER],
    alpha: 0,
    duration: 100,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.UI.Button.prototype.onDown = function () {
  if (this.sprites[this.states.BTN_STATE_DOWN]) {
    this.sprites[this.states.BTN_STATE_DOWN].setAlpha(1);
  }
  if (this.sprites[this.states.BTN_STATE_HOVER]) {
    this.sprites[this.states.BTN_STATE_HOVER].setAlpha(0);
  }
};
/**
 *
 */
EDC.UI.Button.prototype.setClickCallback = function (callback) {
  this.clickCallback = callback;
};
/**
 *
 */
EDC.UI.Button.prototype.setOverCallback = function (callback) {
  this.overCallback = callback;
};
/**
 *
 */
EDC.UI.Button.prototype.setOutCallback = function (callback) {
  this.outCallback = callback;
};
/**
 *
 */
EDC.UI.Button.prototype.addState = function (state, spriteId) {
  if (spriteId) {
    const stateSprite = this.scene.add.sprite(0, 0, spriteId);
    if (spriteId === 'menu-btn-switch-normal') {
      const switchContainer = this.addSwitchIcon();
      this.container.add(switchContainer);
    }

    this.sprites[state] = stateSprite;
    this.container.add(stateSprite);

    if (
      state === this.states.BTN_STATE_HOVER
      || state === this.states.BTN_STATE_DOWN
      || state === this.states.BTN_STATE_DISABLED
    ) {
      stateSprite.setAlpha(0);
    }
  }
};
/**
 *
 */
EDC.UI.Button.prototype.setPosition = function (newX, newY) {
  this.x = newX;
  this.y = newY;
  this.container.setPosition(this.x, this.y);
};
/**
 *
 */
EDC.UI.Button.prototype.getSize = function () {
  return { width: this.container.displayWidth, height: this.container.displayHeight };
};

/**
 *
 */
EDC.UI.Button.prototype.addSwitchIcon = function () {
  const activeAccount = store.getters['children/activeChildProfile'];
  const icon = this.scene.add.sprite(0, 0, 'menu-account-image');
  let name = activeAccount.first_name
    ? `${activeAccount.first_name} ${activeAccount.last_name}`
    : activeAccount.nickname;
  if (name.length > 12) {
    name = `${name.substring(0, 10)}...`;
  }
  const text = this.scene.add.text(0, 80, name);
  const circle = new Phaser.Geom.Circle(0, 0, 80);
  const graphics = this.scene.add.graphics({
    lineStyle: { width: 5, color: 0x000000 },
    fillStyle: { color: 0xffffff },
  });
  graphics.fillCircleShape(circle);
  graphics.strokeCircleShape(circle);
  icon.setScale(0.28);
  text.setFontSize(36);
  text.setColor('#fff');
  text.setOrigin(0.5, 0);

  const container = this.scene.add.container(0, -170, [graphics, icon, text]);
  container.setSize(267, 180);
  container.setInteractive();
  container.on('pointerdown', () => {
    router.push({ name: 'profile' });
  });
  console.log('this', this)
  const cursorManager = new CursorManager(this.scene.game.canvas);
  cursorManager.setDefaultDraggableEvents(container);
  return container;
};

export default EDC.UI.Button;
